module.exports = __webpack_public_path__ + "img/activate.ed72db1d.svg";